import { render, staticRenderFns } from "./OctCardListItem.vue?vue&type=template&id=165759bc&scoped=true&"
import script from "./OctCardListItem.vue?vue&type=script&lang=js&"
export * from "./OctCardListItem.vue?vue&type=script&lang=js&"
import style0 from "./OctCardListItem.vue?vue&type=style&index=0&id=165759bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165759bc",
  null
  
)

export default component.exports